export default __webpack_public_path__ + "static/media/happy.a825387c.jpg";